export default __webpack_public_path__ + "static/media/politicas_sgsi_2025.6ba6867a.pdf";